import { render, staticRenderFns } from "./DropdownGarage.vue?vue&type=template&id=267f2564&scoped=true&"
import script from "./DropdownGarage.vue?vue&type=script&lang=ts&"
export * from "./DropdownGarage.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownGarage.vue?vue&type=style&index=0&id=267f2564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f2564",
  null
  
)

export default component.exports